// src/services/dispositivos/exportPdfDispositivo.js
import http from "@/services/api/http.js";

/**
 * Exporta el reporte del dispositivo consumiendo la API del backend
 * @param {string|number} id - ID del dispositivo
 * @param {string} formato - Formato deseado ('pdf' o 'excel')
 */
export async function exportarDispositivoPDF(id, formato = "pdf") {
  try {
    const response = await http.get(`/dispositivos/api/dispositivos/${id}/reporte/`, {
      params: { formato },
      responseType: "blob",
    });

    const blob = new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;

    const extension = formato === "excel" ? "xls" : "pdf";
    a.download = `reporte_dispositivo_${id}.${extension}`;

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error(`Error al exportar el reporte en formato ${formato}:`, error);
    throw error;
  }
}
